import groupBy from 'lodash/groupBy'
import { computed, makeObservable } from 'mobx'

import TemplateWeek, {
  ITemplateWeek,
  TTemplateWeek,
} from 'modules/shift_management/store/internal/models/TemplateWeek'

class TemplateWeeks {
  templateWeeks: TemplateWeek[]

  constructor(templateWeeks: TemplateWeek[]) {
    this.templateWeeks = templateWeeks

    makeObservable(this, {
      _groupedById: computed,
    })
  }

  /**
   * Transforms an array of objects from a request into an array of TemplateWeek
   * objects
   */
  /**
   * @deprecated Before using this method, consider using the `buildFromGraphQL` hook since
   * we are trying to move away from using mobx-rest and use GraphQL instead.
   */
  static buildFromProps(templateWeeks: ITemplateWeek[]): TemplateWeeks {
    const templateWeekObjects = templateWeeks.map((templateWeek) => {
      return TemplateWeek.buildFromProps(templateWeek)
    })

    return new TemplateWeeks(templateWeekObjects)
  }

  static buildFromGraphQL(templateWeeks: TTemplateWeek[]): TemplateWeeks {
    const templateWeekObjects = templateWeeks.map((templateWeek) => {
      return TemplateWeek.buildFromGraphQL(templateWeek)
    })

    return new TemplateWeeks(templateWeekObjects)
  }

  get _groupedById(): Record<number, TemplateWeek[]> {
    return groupBy(this.templateWeeks, (templateWeek) => templateWeek.id)
  }

  findById(id: number): TemplateWeek | undefined {
    return this._groupedById[id]?.[0]
  }
}

export default TemplateWeeks
